import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import SvgIcon from '@material-ui/core/SvgIcon';

const CategoryIcon: React.FunctionComponent = () => {
    return (
        <IconButton aria-label="categories" className="ktm-icon">
            <SvgIcon>
                <title>Categories Icon</title>
                <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g id="Konfigurator-Startsteite" transform="translate(-764.000000, -42.000000)">
                        <g id="Icon-Kategorien" transform="translate(764.000000, 42.000000)">
                            <rect id="Rectangle" fill="#999999" x="6" y="0" width="20" height="16.9230769"></rect>
                            <rect id="Rectangle" fill="#CCCBCB" x="3" y="2.53846154" width="20" height="16.9230769"></rect>
                            <rect id="Rectangle" fill="#F5F5F5" x="0" y="5.07692308" width="20" height="16.9230769"></rect>
                        </g>
                    </g>
                </g>
            </SvgIcon>
        </IconButton>
    );
}

export default CategoryIcon;